import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.6471 18.01L6.6971 13.061L8.1101 11.646L11.6471 15.183L20.1321 6.69699L21.5461 8.11099L11.6461 18.011L11.6471 18.01ZM7.4041 18.01L2.4541 13.061L3.8681 11.646L8.8181 16.596L7.4051 18.01H7.4041ZM11.6471 13.768L10.2321 12.354L16.5961 5.98999L18.0111 7.40399L11.6471 13.767V13.768Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CheckAll"
);
